// extracted by mini-css-extract-plugin
module.exports = {"content":"products_content__3xuAU","center":"products_center__2Ulkv"};